import {
  GET_HOME,
  GET_HOME_SUCCESS,
  GET_BRANDS,
  GET_BRANDS_SUCCESS,
  GET_PLANS,
  GET_PLANS_SUCCESS
} from '../../constants/constants';

export const getBrands = () => ({
  type: GET_BRANDS
});

export const getBrandsSuccess = (brands) => ({
  type: GET_BRANDS_SUCCESS,
  payload: brands
});

export const getHome = () => ({
  type: GET_HOME
});

export const getHomeSuccess = (payload) => ({
  type: GET_HOME_SUCCESS,
  payload
});

export const getPlans = () => ({
  type: GET_PLANS
});

export const getPlansSuccess = (plans) => ({
  type: GET_PLANS_SUCCESS,
  payload: plans
});
